// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.GlobalTopicFilter .GlobalTopicFilter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.GlobalTopicFilter .GlobalTopicFilter-header .GlobalTopicFilter-clear-button {
  margin: 0;
  padding: 0 !important;
  display: none;
  height: 20px;
}
.GlobalTopicFilter:hover .GlobalTopicFilter-clear-button {
  display: inherit;
}
.GlobalTopicFilter .GlobalTopicFilter-search input {
  line-height: 160%;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.GlobalTopicFilter .GlobalTopicFilter-list {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  height: 160px;
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar-track {
  background: transparent;
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.GlobalTopicFilter .GlobalTopicFilter-list:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.GlobalTopicFilter .GlobalTopicFilter-list {
  margin: 0px 0 0 -6px;
  padding: 6px 4px 20px 6px;
}
.GlobalTopicFilter .GlobalTopicFilter-list * {
  box-sizing: content-box;
}
.GlobalTopicFilter .GlobalTopicFilter-list .GlobalTopicFilter-item {
  padding: 3px 0;
}
.GlobalTopicFilter .GlobalTopicFilter-list::after {
  content: "";
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.67%, #FFF 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(100% - 7px);
  height: 20px;
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar-track {
  background: transparent;
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.GlobalTopicFilter .GlobalTopicFilter-list:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.GlobalTopicFilter .GlobalTopicFilter-list::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/global-topic/global-topic-filter/global-topic-filter.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAVE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAYJ;AAVI;EACE,SAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;AAYN;AAPI;EACE,gBAAA;AASN;AAJI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAMN;AAFE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;AAIJ;AD9BE;EACE,UAAA;EACA,WAAA;ACgCJ;AD7BE;EACE,uBAAA;AC+BJ;AD5BE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;AC8BJ;AD1BI;EACE,oCApBS;ACgDf;ADxBE;EACE,oCAxBY;ACkDhB;AA5BE;EAQE,oBAAA;EACA,yBAAA;AAuBJ;AArBI;EACE,uBAAA;AAuBN;AApBI;EACE,cAAA;AAsBN;AAnBI;EACE,WAAA;EACA,6EAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;AAqBN;ADnEE;EACE,UAAA;EACA,WAAA;ACqEJ;ADlEE;EACE,uBAAA;ACoEJ;ADjEE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACmEJ;AD/DI;EACE,oCApBS;ACqFf;AD7DE;EACE,oCAxBY;ACuFhB","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.GlobalTopicFilter {\n\n\n  .GlobalTopicFilter-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n\n    .GlobalTopicFilter-clear-button {\n      margin: 0;\n      padding: 0 !important;\n      display: none;\n      height: 20px;\n    }\n  }\n\n  &:hover {\n    .GlobalTopicFilter-clear-button {\n      display: inherit;\n    }\n  }\n\n  .GlobalTopicFilter-search {\n    input {\n      line-height: 160%;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n\n  .GlobalTopicFilter-list {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    overflow-y: auto;\n    height: 160px;\n    @include scrollbar;\n    margin: 0px 0 0 -6px;\n    padding: 6px 4px 20px 6px;\n\n    * {\n      box-sizing: content-box;\n    }\n\n    .GlobalTopicFilter-item {\n      padding: 3px 0;\n    }\n\n    &::after {\n      content: '';\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 16.67%, #FFF 100%);\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: calc(100% - 7px);\n      height: 20px;\n    }\n\n    @include scrollbar;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
